/*
 * @Author: czj
 * @Date: 2025-04-17 14:50:45
 * @Description: 
 * @FilePath: \sxtracellular-single-cell\src\locales\language\en.js
 */
export default {
  "name": "China Brain Injury Atlas",
  "greeting": 'Hello, World!',
  "button": {
    "save": 'Save',
    "cancel": 'Cancel',
    "confirm": 'Confirm'
  },
  "newTable": {
    "search": 'Search',
    "reset": 'Reset',
    "back": 'Back',
    "more": 'More',
    "noSearch": 'No search',
    "inputPlaceholder": 'Please input',
    "selectPlaceholder": 'Please select',
    "metaCategory": 'Metadata category',
    "viewJson": 'View JSON',
    "yes": 'Yes',
    "no": 'No',
    "preview": 'Preview',
    "noFileSelected": 'No file selected',
    "failedToLoad": 'Failed to load',
    "copySuccess": 'Copied!',
    "selectPrefix": 'Please select',
    "addPrefix": 'Add',
    "viewPrefix": 'View',
    "inputPrefix": 'Please input',
    "uploadPrefix": 'Please upload',
    "selectFile": 'Select file',
    "addColumn": 'Add column',
    "dataField": 'Data field',
    "displayName": 'Display name',
    "isVisible": 'Visible',
    "dataType": 'Data type',
    "isReadOnly": 'Read only',
    "isSearch": 'Searchable',
    "dataSource": 'Data source',
    "actions": 'Actions',
    "delete": 'Delete',
    "sourceConfig": 'Source config',
    "sourceType": 'Source type',
    "dataTable": 'Table',
    "dictData": 'Dictionary',
    "label": 'Label',
    "matchValue": 'Match value',
    "inputDictName": 'Please input dict name',
    "selectType": 'Please select type',
    "dataError": 'Data error, please refresh and retry',
    "submitFailed": 'Submit failed, contact admin',
    "configSource": 'Config source'
  },
  "login": {
    "title": "Welcome back!",
    "tip": "Login with your account!",
    "email": "Email",
    "password": "Password",
    "login": " Sign In ",
    "forgot": "Don't have an account?",
    "signup": "Sign Up Now",
    "retrieve": "Forgot password?"
  },
  "topbar": {
    "logout": "log out",
    "signin": "sign in",
  },
  "route": {
    "dataset": "Dataset",
    "analysis": "Analysis",
    "help": "Help",
    "contact": "Contact"
  },
  "home": {
    "dataset": "Dataset",
    "cellnum": "Cell Number",
    "intro": "Intro"
  }
}
